import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";
import styled from "styled-components";
import {
  BaseFieldStyle,
  ErrorText,
  FieldWrapper,
  Label,
  RequiredMark,
} from "./SharedFormStyles";

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    ${BaseFieldStyle}
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & input {
    padding: 10px;
    font-family: ${({ theme }) => theme.fonts.primary};
  }

  & .MuiAutocomplete-inputRoot {
    padding: 0;
  }
`;

const FormYearPickerField = ({
  label,
  name,
  control,
  error,
  required = false,
  startYear = 1900,
  endYear = new Date().getFullYear(),
  disabled = false,
}) => {
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => endYear - i
  );

  return (
    <FieldWrapper>
      <Label>
        {label} {required && <RequiredMark>*</RequiredMark>}
      </Label>

      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            options={years}
            disabled={disabled}
            value={value || null}
            onChange={(event, newValue) => onChange(newValue)}
            isOptionEqualToValue={(option, val) => option === val}
            getOptionLabel={(option) => String(option)}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                placeholder="Select year"
                error={!!error}
              />
            )}
          />
        )}
      />

      {error && <ErrorText variant="caption">{error.message}</ErrorText>}
    </FieldWrapper>
  );
};

FormYearPickerField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  control: PropTypes.object.isRequired,
  error: PropTypes.object,
  required: PropTypes.bool,
  startYear: PropTypes.number,
  endYear: PropTypes.number,
  disabled: PropTypes.bool,
};

export default FormYearPickerField;
